<template>
  <div class="property-notice-info app-region blank-t-v blank-b-v blank-l-h blank-r-h" v-if="!isScan">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="公告标题" prop="name">
        <a-input v-model="form.name" placeholder="请输入公告标题" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="公告封面" prop="avatar">
        <a-upload name="media" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange">
          <dy-image :src="form.avatar" v-if="form.avatar" preview></dy-image>
          <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="公告内容" prop="note">
        <editor name="editor" v-model="form.note"></editor>
      </a-form-model-item>
      <a-form-model-item label="发布社区" prop="community">
        <a-select mode="multiple" v-model="form.community" placeholder="请选择发布社区" :disabled="!isPlatformRole">
          <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="接收人群" prop="receivePeople">
        <a-radio-group v-model="form.receivePeople">
          <a-radio :value="1">全部住户</a-radio>
          <a-radio :value="2">按房屋身份</a-radio>
          <a-radio :value="3">按房源架构</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="房屋身份" prop="identity" v-if="form.receivePeople === 2">
        <a-select mode="multiple" v-model="form.identity" placeholder="请选择房屋身份">
          <a-select-option :value="1">{{houseIdentityText(1)}}</a-select-option>
          <a-select-option :value="2">{{houseIdentityText(2)}}</a-select-option>
          <a-select-option :value="3">{{houseIdentityText(3)}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="房源架构" prop="house" v-if="form.receivePeople === 3">
        <div>
          <a-button type="primary" @click="showModal">选择</a-button>
        </div>
        <div>
          <a-tag class="large" closable @close.prevent="delHouse(index)" v-for="(value, index) in form.house" :key="index">{{value.full_name}}</a-tag>
        </div>
      </a-form-model-item>
      <a-form-model-item label="消息推送" prop="push">
        <a-radio-group v-model="form.push">
          <a-radio :value="1">推送</a-radio>
          <a-radio :value="0">不推送</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="发布方式" prop="publishType">
        <a-radio-group v-model="form.publishType">
          <a-radio value="now">立即发布</a-radio>
          <a-radio value="defer">定时发布</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="发布时间" prop="publishTime" v-if="form.publishType === 'defer'">
        <a-date-picker v-model="form.publishTime" placeholder="请选择发布时间" show-time valueFormat="YYYY-MM-DD HH:mm:ss"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.house" :data="tree.data" :params="tree.params" :load-data="$houseTreeData" multiple @load="loadTreeSelectNode">
        <template slot-scope="{row}">
          <a-row type="flex">
            <a-col flex="1">{{row[tree.params.title]}}</a-col>
            <a-col>
              <dy-icon type="icon-batch" @click.stop="batchSelectHome(row)"></dy-icon>
            </a-col>
          </a-row>
        </template>
      </tree-select>
    </a-modal>
    <a-modal :title="batchModal.title" v-model="batchModal.show" @ok="confirmBatchModal" destroy-on-close width="60%" centered>
      <batch-select-house :init-data="batchModal.data" v-model="batchModal.house"></batch-select-house>
    </a-modal>
  </div>
  <div class="property-notice-info" v-else>
    <a-descriptions bordered v-viewer>
      <a-descriptions-item label="公告标题">{{form.name}}</a-descriptions-item>
      <a-descriptions-item label="公告封面" :span="2">
        <dy-image :src="form.avatar"></dy-image>
      </a-descriptions-item>
      <a-descriptions-item label="公告内容" :span="3"><span v-html="form.note"></span></a-descriptions-item>
      <a-descriptions-item label="发布社区">{{communityOptions.filter(val => form.community.indexOf(val.id) > -1).map(val => val.name).join('、')}}</a-descriptions-item>
      <a-descriptions-item label="接收人群">{{form.receivePeople === 1 ? '全部住户' : (form.receivePeople === 2 ? '按房屋身份' : '按房源架构')}}</a-descriptions-item>
      <a-descriptions-item label="房屋身份" v-if="form.receivePeople === 2">{{form.identity.map(val => houseIdentityText(val)).join('、')}}</a-descriptions-item>
      <a-descriptions-item label="房源架构" v-if="form.receivePeople === 3">{{form.house.map(val => val.full_name).join('、')}}
      </a-descriptions-item>
      <a-descriptions-item label="消息推送">{{form.push ? '推送' : '不推送'}}</a-descriptions-item>
      <a-descriptions-item label="发布方式">{{form.publishType === 'now' ? '立即发布' : '定时发布'}}</a-descriptions-item>
      <a-descriptions-item label="发布时间" v-if="form.publishType === 'defer'">{{form.publishTime}}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
  import {
    houseIdentityText
  } from '@/io/dict.js';
  import CommunityService from '@/io/community.js';
  import PropertyNoticeService from '@/io/property_notice.js';

  export default {
    name: 'PropertyNoticeInfo',
    props: {
      isScan: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        default() {
          return this.$route.params.id * 1;
        }
      }
    },
    data() {
      return {
        houseIdentityText,
        avatar: {
          loading: false
        },
        communityOptions: [],
        form: {
          name: null,
          avatar: null,
          note: null,
          community: [],
          receivePeople: null,
          identity: [],
          house: [],
          push: null,
          publishType: null,
          publishTime: null
        },
        rules: {
          name: [
            {
              required: true,
              message: '请输入公告标题'
            }
          ],
          avatar: [
            {
              required: true,
              message: '请上传公告封面'
            }
          ],
          note: [
            {
              required: true,
              message: '请填写公告内容'
            }
          ],
          community: [
            {
              required: true,
              message: '请填写发布社区'
            }
          ],
          receivePeople: [
            {
              required: true,
              message: '请选择接收人群'
            }
          ],
          identity: [
            {
              required: true,
              message: '请选择房屋身份'
            }
          ],
          house: [
            {
              required: true,
              message: '请选择房源'
            }
          ],
          push: [
            {
              required: true,
              message: '请选择消息推送'
            }
          ],
          publishType: [
            {
              required: true,
              message: '请选择发布方式'
            }
          ],
          publishTime: [
            {
              required: true,
              message: '请选择发布时间'
            }
          ],
        },
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'name',
            key: '_id'
          }
        },
        modal: {
          title: '选择房源',
          show: false,
          house: []
        },
        batchModal: {
          title: '批量选择房间',
          show: false,
          house: [],
          data: []
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initCommunity().then(() => {
            this.initPage();
          });
        },
        immediate: true
      },
      'form.receivePeople': {
        handler(newValue, oldValue) {
          if (newValue === 3) {
            this.$houseTreeData(this.isPlatformRole ? this.$createNewVariable(this.communityOptions.filter(val => this.form.community.indexOf(val.id) > -1)) : [], [this.isPlatformRole ? 0 : 1, 4]).then(res => {
              this.tree.data = res.map(val => {
                val.disabled = !!this.isPlatformRole;
                return val;
              });
            })
          }
        },
        immediate: true
      }
    },
    methods: {
      loadTreeSelectNode(data) {
        if (data.level === 2) {
          this.$set(data, 'scopedSlots', {
            title: 'title'
          });
        }
      },
      confirmBatchModal() {
        let house = [];
        this.batchModal.house.forEach(val => {
          if (this.modal.house.map(m => m[this.tree.params.key]).indexOf(val[this.tree.params.key]) === -1) {
            house.push(val);
          }
        });
        this.modal.house = this.modal.house.concat(house);
        this.batchModal.show = false;
        this.batchModal.house = [];
        this.batchModal.data = [];
      },
      batchSelectHome(data) {
        this.batchModal.data = data.children.map(val => val.children);
        this.batchModal.show = true;
      },
      initPage() {
        if (this.$getCookie('communityId')) {
          this.form.community = [this.$getCookie('communityId') * 1];
        }
        if (this.id) {
          PropertyNoticeService.info(this.id).then(res => {
            this.form.name = res.title;
            this.form.avatar = res.banner;
            this.form.note = res.content;
            this.form.community = res.community_ids;
            this.form.receivePeople = res.accept_owner_type;
            this.form.identity = res.accept_owner;
            this.form.house = [...res.accept_owner_building, ...res.accept_owner_unit, ...res.accept_owner_floor, ...res.accept_owner_room].map(val => {
              return {
                _id: val.id,
                id: val.id,
                full_name: val.full_name
              }
            });
            this.form.push = res.is_notify;
            this.form.publishType = res.publish_way;
            this.form.publishTime = res.defer_at;
          }).catch(err => {});
        }
      },
      showModal() {
        this.modal.show = true;
        this.modal.house = this.$createNewVariable(this.form.house);
      },
      confirmModal() {
        this.modal.show = false;
        this.form.house = this.$createNewVariable(this.modal.house);
      },
      delHouse(index) {
        this.form.house.splice(index, 1);
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      handleChange(info) {
        let status = info.file.status;
        if (status) {
          if (status === 'done') {
            this.avatar.loading = false;
            this.form.avatar = info.file.response.media;
          } else {
            this.avatar.loading = true;
          }
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            PropertyNoticeService.edit(
              this.id,
              this.form.name,
              this.form.avatar,
              this.form.note,
              this.form.community,
              this.form.receivePeople,
              this.form.identity,
              this.form.house.filter(val => val.level === 1).map(val => val.id),
              this.form.house.filter(val => val.level === 2).map(val => val.id),
              this.form.house.filter(val => val.level === 3).map(val => val.id),
              this.form.house.filter(val => val.level === 4).map(val => val.id),
              this.form.push,
              this.form.publishType,
              this.form.publishTime
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            PropertyNoticeService.add(
              this.form.name,
              this.form.avatar,
              this.form.note,
              this.form.community,
              this.form.receivePeople,
              this.form.identity,
              this.form.house.filter(val => val.level === 1).map(val => val.id),
              this.form.house.filter(val => val.level === 2).map(val => val.id),
              this.form.house.filter(val => val.level === 3).map(val => val.id),
              this.form.house.filter(val => val.level === 4).map(val => val.id),
              this.form.push,
              this.form.publishType,
              this.form.publishTime
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push({
          name: 'PropertyNotice'
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  
</style>